import ClientOnly from "./ClientOnly.js";

export function registerComponents (app) {
	app.component("ClientOnly", ClientOnly);
}
